<section class="md:h-screen py-36 flex items-center bg-[url('../../assets/images/cta.jpg')] bg-no-repeat bg-center">
  <div class="absolute top-0 start-0 w-full h-full z-0 pointer-events-none overflow-hidden">
    <iframe src="https://player.vimeo.com/video/235428555?background=1&autoplay=1&loop=1&byline=0&title=0" class="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-screen h-[56.25vw] min-h-screen min-w-[177.77vw]"></iframe>
  </div>
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
  <div class="container">
    <div class="flex justify-center">
      <div class="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-slate-900 shadow-md dark:shadow-gray-800 rounded-md">
        <a [routerLink]="'/'">
          <img [src]="'assets/images/logo-dark.png'" class="mx-auto h-7 block dark:hidden" alt="">
          <img [src]="'assets/images/logo-light.png'" class="mx-auto h-7 dark:block hidden" alt="">
        </a>
        <h5 class="my-6 text-xl font-semibold">{{ 'PASSWORD.RESET_PASSWORD_TITLE' | translate }}</h5>

        <!-- Error message display -->
        <div *ngIf="errorMessage" class="my-4 p-3 bg-red-100 text-red-700 rounded-md">
          {{ errorMessage }}
        </div>

        <div *ngIf="!successMessage" class="my-4 p-3 bg-green-100 text-green-700 rounded-md">
          {{ 'PASSWORD.RESET_SENT_ALERT' | translate }}
        </div>

        <!-- Success message display -->
        <div *ngIf="successMessage" class="my-4 p-3 bg-green-100 text-green-700 rounded-md">
          {{ successMessage | translate }}
        </div>

        <!-- Reset Password Form -->
        <div *ngIf="!resetComplete">
          <div class="grid grid-cols-1">
            <p class="text-slate-400 mb-6">{{ 'PASSWORD.RESET_PASSWORD_DESC' | translate }}</p>

            <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="text-start">
              <div class="grid grid-cols-1">
                <div class="mb-4">
                  <label class="font-semibold" for="email">{{ 'PASSWORD.EMAIL' | translate }}:</label>
                  <input id="email" type="email" formControlName="email"
                         class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3"
                         [ngClass]="{'bg-gray-100 dark:bg-slate-800': resetPasswordForm.get('email')?.disabled}"
                         placeholder="name@example.com">
                  <div *ngIf="resetPasswordForm.get('email')?.disabled" class="text-gray-500 text-sm mt-1">
                    <i class="fas fa-lock mr-1"></i> {{ 'PASSWORD.EMAIL_LOCKED' | translate }}
                  </div>
                  <div *ngIf="resetPasswordForm.get('email')?.invalid && resetPasswordForm.get('email')?.touched" class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.INVALID_EMAIL' | translate }}
                  </div>
                </div>

                <div class="mb-4">
                  <label class="font-semibold" for="code">{{ 'PASSWORD.RESET_CODE' | translate }}:</label>
                  <input id="code" type="text" formControlName="code" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="12345678">
                  <div *ngIf="resetPasswordForm.get('code')?.invalid && resetPasswordForm.get('code')?.touched" class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.INVALID_CODE' | translate }}
                  </div>
                </div>

                <div class="mb-4">
                  <label class="font-semibold" for="password">{{ 'PASSWORD.NEW_PASSWORD' | translate }}:</label>
                  <input id="password" type="password" formControlName="password" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="********">
                  <div *ngIf="resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched" class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.INVALID_PASSWORD' | translate }}
                  </div>
                </div>

                <div class="mb-4">
                  <label class="font-semibold" for="confirmPassword">{{ 'PASSWORD.CONFIRM_PASSWORD' | translate }}:</label>
                  <input id="confirmPassword" type="password" formControlName="confirmPassword" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3" placeholder="********">
                  <div *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['required'] && resetPasswordForm.get('confirmPassword')?.touched" class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate }}
                  </div>
                  <div *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['passwordMismatch'] && resetPasswordForm.get('confirmPassword')?.touched" class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.PASSWORDS_DONT_MATCH' | translate }}
                  </div>
                </div>

                <div class="mb-4">
                  <button type="submit" [disabled]="resetPasswordForm.invalid || isLoading" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full w-full">
                    <span *ngIf="!isLoading">{{ 'PASSWORD.RESET_PASSWORD_BTN' | translate }}</span>
                    <span *ngIf="isLoading">{{ 'PASSWORD.RESETTING_PASSWORD_BTN' | translate }}</span>
                  </button>
                </div>

                <div class="text-center">
                  <span class="text-slate-400 me-2">{{ 'PASSWORD.REMEMBER_PASSWORD' | translate }} </span><a [routerLink]="'/login'" class="text-black dark:text-white font-bold">{{ 'PASSWORD.SIGN_IN' | translate }}</a>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Success View -->
        <div *ngIf="resetComplete" class="grid grid-cols-1">
          <div class="text-center mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 text-green-500 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <p class="text-slate-400 mt-4">{{ 'PASSWORD.RESET_SUCCESS_DESC' | translate }}</p>
          </div>
          <div class="mb-4">
            <button type="button" (click)="goToLogin()" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full w-full">
              {{ 'PASSWORD.GO_TO_LOGIN' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-back-to-home/>
